import { render, staticRenderFns } from "./BaseSearchLayout.vue?vue&type=template&id=6162cc9a&"
import script from "./BaseSearchLayout.vue?vue&type=script&lang=ts&"
export * from "./BaseSearchLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports